import {
	GET_ADVISORY_AGREEMENT_SUCCESS,
	GET_ADVISORY_SIGNATURE_SUCCESS,
	POST_ADVISORY_SIGNATURE_SUCCESS,
} from 'stash/actions/api';

export const initialState = {
	agreements: [],
	disclosureStatement: {},
	coreDisclosureStatement: null,
	signature: {},
};

const advisory_agreements = (state = initialState, action) => {
	switch (action.type) {
		case GET_ADVISORY_AGREEMENT_SUCCESS: {
			return {
				...state,
				agreements: action.response.agreement.agreements,
				disclosureStatement: action.response.agreement.disclosureStatement,
				coreDisclosureStatement:
					action.response.agreement.coreDisclosureStatement || null,
			};
		}
		case GET_ADVISORY_SIGNATURE_SUCCESS:
		case POST_ADVISORY_SIGNATURE_SUCCESS: {
			return {
				...state,
				signature: action.response.userEsignature,
			};
		}
		default:
			return state;
	}
};

export default advisory_agreements;
